export const banks = [
  { label: "Banco ABC Brasil", value: "246" },
  { label: "Banco Agibank", value: "121" },
  { label: "Banco Alfa", value: "025" },
  { label: "Banco Asaas", value: "461" },
  { label: "Banco B3", value: "194" },
  { label: "Banco Bari", value: "250" },
  { label: "Banco Banestes", value: "021" },
  { label: "Banco Banrisul", value: "041" },
  { label: "Banco Banif", value: "719" },
  { label: "Banco Bandepe", value: "096" },
  { label: "Banco Barigui", value: "063" },
  { label: "Banco BBM", value: "107" },
  { label: "Banco BMG", value: "318" },
  { label: "Banco Bonsucesso", value: "218" },
  { label: "Banco Bradesco", value: "237" },
  { label: "Banco BRICS", value: "250" },
  { label: "Banco BTG Pactual", value: "208" },
  { label: "Banco C6", value: "336" },
  { label: "Banco Caixa", value: "104" },
  { label: "Banco CCB Brasil", value: "320" },
  { label: "Banco Cora", value: "403" },
  { label: "Banco Citibank", value: "745" },
  { label: "Banco Crefisa", value: "069" },
  { label: "Banco Daimler", value: "751" },
  { label: "Banco Daycoval", value: "707" },
  { label: "Banco do Brasil", value: "001" },
  { label: "Banco do Estado do Ceará", value: "222" },
  { label: "Banco do Estado do Espírito Santo (Banestes)", value: "021" },
  { label: "Banco do Nordeste", value: "004" },
  { label: "Banco Fibra", value: "224" },
  { label: "Banco Ficsa", value: "626" },
  { label: "Banco GMAC", value: "090" },
  { label: "Banco Indusval", value: "653" },
  { label: "Banco Industrial do Brasil", value: "604" },
  { label: "Banco Inter", value: "077" },
  { label: "Banco Intermedium (Banco Inter)", value: "077" },
  { label: "Banco Itaú", value: "341" },
  { label: "Banco Máxima", value: "243" },
  { label: "Banco Mercantil", value: "389" },
  { label: "Banco Modal", value: "746" },
  { label: "Banco Neon", value: "735" },
  { label: "Banco Olé Bonsucesso", value: "096" },
  { label: "Banco Original", value: "212" },
  { label: "Banco Ourinvest", value: "092" },
  { label: "Banco Pan", value: "623" },
  { label: "Banco Paraná Banco", value: "254" },
  { label: "Banco Paulista", value: "611" },
  { label: "Banco Pine", value: "643" },
  { label: "Banco Plural", value: "269" },
  { label: "Banco Porto Real", value: "232" },
  { label: "Banco Renner", value: "633" },
  { label: "Banco Regional de Brasília (BRB)", value: "070" },
  { label: "Banco Rodobens", value: "120" },
  { label: "Banco Rural", value: "453" },
  { label: "Banco Safra", value: "422" },
  { label: "Banco Santander", value: "033" },
  { label: "Banco Sicredi", value: "748" },
  { label: "Banco Sicoob", value: "756" },
  { label: "Banco Sofisa", value: "637" },
  { label: "Banco Sumitomo Mitsui", value: "464" },
  { label: "Banco Topázio", value: "082" },
  { label: "Banco Triângulo", value: "634" },
  { label: "Banco UNICRED", value: "136" },
  { label: "Banco Votorantim", value: "655" },
  { label: "Banco Volkswagen", value: "370" },
  { label: "Banco do Nordeste", value: "004" },
  { label: "Banco do Estado do Espírito Santo (Banestes)", value: "021" },
  { label: "Banco Regional de Brasília (BRB)", value: "070" },
  { label: "Nu Pagamentos (Nubank)", value: "260" },
  { label: "IB3 Capital", value: "999" },
];